var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "home-page" },
    [
      _c(
        "router-link",
        { staticClass: "search-bar", attrs: { to: { path: "/search" } } },
        [
          _c(
            "search",
            {
              key: "home-search",
              attrs: {
                readonly: true,
                placeholder: _vm.placeholder,
                value: "",
              },
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isShowScanner,
                      expression: "isShowScanner",
                    },
                  ],
                  staticClass: "saoyisao",
                  attrs: { slot: "right" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.saoyisao.apply(null, arguments)
                    },
                  },
                  slot: "right",
                },
                [
                  _c("icon", { attrs: { size: "27", color: "#2E2F30" } }, [
                    _vm._v("saoyisao-erweimachaxun"),
                  ]),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("menus", {
        attrs: {
          categoryList: _vm.categoryList,
          currentId: _vm.currentMenusId,
        },
        on: {
          "select-change": _vm.categoryChange,
          onShowStateChange: _vm.whenMenusChange,
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "notices-fixed" },
        [
          _c("Notices", {
            on: {
              clearTime: _vm.clearTime,
              isShow: (data) => {
                _vm.isShowNotices = data
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "home-content",
          style: { marginTop: _vm.isShowNotices ? "49px" : "0px" },
        },
        [_c("home-content-main", { attrs: { swipeAuto: _vm.swipeAuto } })],
        1
      ),
      _vm._v(" "),
      _vm.getError
        ? _c("default-page", {
            attrs: { allReload: true, showRefreshBtn: true },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }